import React from 'react';
import { FormControl, Select } from '@mui/material';
import { Controller } from 'react-hook-form';
import MenuItem from '@mui/material/MenuItem';
import InputBase from '@mui/material/InputBase';
import get from 'lodash/get';
import { withStyles } from '@mui/styles';
import { phrases, validator } from 'myValidation';
import { FieldWrapper } from 'components';
import { useStyles } from './style';

const BootstrapInput = withStyles((theme) => {
  return {
    root: {
      '& .MuiSelect-nativeInput': {
        padding: '1.5px 4px',
      },
      '& .MuiSelect-select:focus': {
        borderRadius: (props) => {
          const r = props.removeRightRadius;
          const l = props.removeLeftRadius;
          return `${l ? 0 : 8}px ${r ? 0 : 8}px ${r ? 0 : 8}px ${l ? 0 : 8}px`;
        },
      },
    },
    input: {
      height: '42.63px',
      boxSizing: 'border-box',
      borderRadius: (props) => {
        const r = props.removeRightRadius;
        const l = props.removeLeftRadius;
        return `${l ? 0 : 4}px ${r ? 0 : 4}px ${r ? 0 : 4}px ${l ? 0 : 4}px`;
      },
      position: 'relative',
      // backgroundColor: "#F6F7F8",
      border: '1px solid #dfdfdf',
      borderRadius: "8px",
      padding: '12px',
      fontFamily: 'Vazir',
      '&::placeholder': {
        direction: 'ltr',
        textAlign: 'left',
      },
    },
  };
})(InputBase);

const SelectV = (props) => {
  let {
    name,
    required,
    errors,
    rules = [],
    options,
    control,
    onChangeFunc,
    forceValue,
    label = null,
    showAsterisk,
    defaultValue = '',
    removeLeftRadius = false,
    removeRightRadius = false,
    ...rest
  } = props;
  const vv = {};
  const classes = useStyles();

  if (!label) {
    let nameField = name;

    if (name.includes('[')) {
      nameField = name.split('[')[0];
    }

    if (name.includes('.')) {
      nameField = `${nameField}.${name.split('.').pop()}`;
    }

    label = phrases.attributes[nameField.replace(/\s*\[.*?\]\s*/g, '')];
  }

  const hasErrorFunc = (name) => {
    if (!rules) {
      return false;
    }

    return get(errors, name, false);
  };

  const hasError = hasErrorFunc(name);

  rules.forEach((item) => {
    vv[item] = (value) =>
      !validator.validators[item](value) ? phrases[item].replace(':attribute', label) : true;
  });

  const id = `select-label-${name}`;

  return (
    <FieldWrapper {...props}>
      <FormControl {...rest} className={classes.root} error={!!hasError}>
        {!control ? (
          <Select
            {...rest}
            labelId={id}
            id={id}
            name={name}
            label={null}
            value={forceValue}
            input={
              <BootstrapInput
                value={forceValue}
                label={null}
                removeLeftRadius={removeLeftRadius}
                removeRightRadius={removeRightRadius}
              />
            }
            onChange={(value) => {
              onChangeFunc(name, value);
            }}
          >
            {options.map((item, key) => (
              <MenuItem key={key} value={item.value} disabled={item?.disabled}>
                {item.label}
              </MenuItem>
            ))}
          </Select>
        ) : onChangeFunc ? (
          <Controller
            render={({ field: { onChange, value } }) => (
              <Select
                {...rest}
                labelId={id}
                id={id}
                name={name}
                label={null}
                value={value}
                input={
                  <BootstrapInput
                    value={value}
                    label={null}
                    removeLeftRadius={removeLeftRadius}
                    removeRightRadius={removeRightRadius}
                  />
                }
                onChange={(value) => {
                  onChange(value);
                  onChangeFunc(name, value);
                }}
              >
                {options.map((item, key) => (
                  <MenuItem key={key} value={item.value}>
                    {item.label}
                  </MenuItem>
                ))}
              </Select>
            )}
            name={name}
            control={control}
            defaultValue={defaultValue}
            rules={{
              validate: {
                ...vv,
              },
            }}
          />
        ) : (
          <Controller
            render={({ field: { onChange, value } }) => (
              <Select
                {...rest}
                labelId={id}
                id={id}
                label={label}
                value={value}
                input={
                  <BootstrapInput
                    value={value}
                    label={null}
                    removeLeftRadius={removeLeftRadius}
                    removeRightRadius={removeRightRadius}
                  />
                }
                onChange={(value) => {
                  onChange(value);
                }}
              >
                {options.map((item, key) => (
                  <MenuItem key={key} value={item.value}>
                    {item.label}
                  </MenuItem>
                ))}
              </Select>
            )}
            name={name}
            control={control}
            defaultValue={defaultValue}
            rules={{
              validate: {
                ...vv,
              },
            }}
          />
        )}
      </FormControl>
    </FieldWrapper>
  );
};

export default SelectV;
